import Rebase from "re-base";
import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBPv1y095Th7TVoeeSRQNqFwRpd3kK5tUg",
    authDomain: "catch-of-the-day-dean-pugh.firebaseapp.com",
    databaseURL: "https://catch-of-the-day-dean-pugh.firebaseio.com",
});

const base = Rebase.createClass(firebaseApp.database());

// this is a named export
export { firebaseApp };

// this is a default export
export default base;




// WEBPACK FOOTER //
// ./src/base.js